var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7178 4.85742H7.35512C7.18599 4.85786 7.01859 4.89164 6.86253 4.95683C6.70646 5.02202 6.56477 5.11734 6.44558 5.23734C6.32638 5.35734 6.23202 5.49966 6.16788 5.65617C6.10374 5.81267 6.07109 5.98029 6.07179 6.14942V12.8748C6.07179 13.5881 6.64646 14.1668 7.35512 14.1668H12.7178C12.8869 14.1663 13.0543 14.1325 13.2104 14.0673C13.3665 14.0022 13.5081 13.9068 13.6273 13.7868C13.7465 13.6668 13.8409 13.5245 13.905 13.368C13.9692 13.2115 14.0018 13.0439 14.0011 12.8748V6.14942C14.0011 5.43609 13.4265 4.85742 12.7178 4.85742Z",
    stroke: "#585960",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9279 4.85701V3.12501C10.9279 2.78234 10.7925 2.45367 10.5519 2.21167C10.4331 2.09187 10.2917 1.99674 10.136 1.93175C9.98029 1.86676 9.81327 1.83321 9.64453 1.83301H4.28187C3.94187 1.83301 3.6152 1.96901 3.3752 2.21167C3.13435 2.45469 2.99901 2.78286 2.99854 3.12501V9.85034C2.99854 10.193 3.13387 10.5217 3.37454 10.7637C3.6152 11.0057 3.9412 11.1423 4.28187 11.1423H6.07187",
    stroke: "#585960",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.72472a565bb6454be084b0fa36f46c21.svg";
export { ForwardRef as ReactComponent };